import Arhar from "../assets/images/arhar.jpeg";
import Bajra from "../assets/images/bajra.jpeg";
import Barley from "../assets/images/barley.jpeg";
import Copra from "../assets/images/copra.jpeg";
import Cotton from "../assets/images/cotton.jpeg";
import Gram from "../assets/images/gram.jpeg";
import Groundnut from "../assets/images/groundnut.jpeg";
import Jowar from "../assets/images/jowar.jpeg";
import Jute from "../assets/images/jute.jpeg";
import Maize from "../assets/images/maize.jpeg";
import Masoor from "../assets/images/masoor.jpeg";
import Moong from "../assets/images/moong.jpeg";
import Niger from "../assets/images/niger.jpeg";
import Paddy from "../assets/images/paddy.jpeg";
import Ragi from "../assets/images/ragi.jpeg";
import Rape from "../assets/images/rape.jpeg";
import Safflower from "../assets/images/safflower.jpeg";
import Sesamum from "../assets/images/sesamum.jpeg";
import Soyabean from "../assets/images/soyabean.jpeg";
import Sugarcane from "../assets/images/sugarcane.jpeg";
import Sunflower from "../assets/images/sunflower.jpeg";
import Urad from "../assets/images/urad.jpeg";
import Wheat from "../assets/images/wheat.jpeg";

const content = {
  Crops: [
    {
      name: "Arhar",
      icon: Arhar,
    },
    {
      name: "Bajra",
      icon: Bajra,
    },
    {
      name: "Barley",
      icon: Barley,
    },
    {
      name: "Copra",
      icon: Copra,
    },
    {
      name: "Cotton",
      icon: Cotton,
    },
    {
      name: "Gram",
      icon: Gram,
    },
    {
      name: "Groundnut",
      icon: Groundnut,
    },
    {
      name: "Jowar",
      icon: Jowar,
    },
    {
      name: "Jute",
      icon: Jute,
    },
    {
      name: "Maize",
      icon: Maize,
    },
    {
      name: "Masoor",
      icon: Masoor,
    },
    {
      name: "Moong",
      icon: Moong,
    },
    {
      name: "Niger",
      icon: Niger,
    },
    {
      name: "Paddy",
      icon: Paddy,
    },
    {
      name: "Ragi",
      icon: Ragi,
    },
    {
      name: "Rape",
      icon: Rape,
    },
    {
      name: "Safflower",
      icon: Safflower,
    },
    {
      name: "Sesamum",
      icon: Sesamum,
    },
    {
      name: "Soyabean",
      icon: Soyabean,
    },
    {
      name: "Sugarcane",
      icon: Sugarcane,
    },
    {
      name: "Sunflower",
      icon: Sunflower,
    },
    {
      name: "Urad",
      icon: Urad,
    },
    {
      name: "Wheat",
      icon: Wheat,
    },
  ],
};

export default content;
